export const supportsAudioOutputSelection = (): boolean =>
    typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype;

export interface DeviceOption {
    readonly deviceId: string;
    readonly label: string;
}

export const toDeviceOptions = (devices: readonly MediaDeviceInfo[], fallbackLabel: string): DeviceOption[] =>
    devices
        .filter(device => device.deviceId && device.deviceId !== 'default')
        .map((device, index) => ({deviceId: device.deviceId, label: device.label || `${fallbackLabel} ${index + 1}`}));
